<div class="col-md-6">
  <div class="card">
    <h3 style="
    margin-bottom: 45px;
">{{options.title}} <img src="{{options.icon}}" style="float: right;
    width: 50px;" /></h3>
    <table class="table table-pos">
      <thead>
        <tr>
          <th>{{ 'pages.dashboardTable.awbNumber'  | translate}}</th>
          <th>{{ 'common.weight'  | translate}}</th>
          <th>{{ 'pages.dashboardTable.consignee'  | translate}}</th>
          <th>{{ 'pages.dashboardTable.phone'  | translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data">
          <td>{{item.ShipmentNo}}</td>
          <td>{{fixDecimals(item.ChargingWeight)}} </td>
          <td>{{item.ConsigneeName}}</td>
          <td>{{item.ConsigneeTel}}</td>
        </tr>
      </tbody>
    </table>
    <nav class="nav-pagination">
      <ul class="pagination">
        <li *ngIf="!(pagesContainer.length <=1) && (pagger != 0)"><button class="btn " (click)="prevPage()"><span class="armx-icon armx-left-dir"></span></button></li>
        <li *ngIf="!(pagesContainer.length <=1) && pagger >= 3"><button class="btn " (click)="getSearchPage(0)">1</button> ..</li>
        <li *ngFor="let a of pagesContainer; let index = index">
          <button *ngIf="((index == pagger) || (pagger <= index + 5) && (index > pagger - 3 && index < pagger + 5) ) && !(pagesContainer <=1)" (click)="getSearchPage(index)" class="btn  {{index == pagger ? 'active' : 'no'}}">{{index+1}}</button>
          {{index < pagger && index >= pagger+5 ? '.' : ''}}
          <button class="btn " *ngIf="index == pagesContainer.length" (click)="getSearchPage(pagger)">{{pagger + 1  }}</button>
        </li>
        <li *ngIf="!(pagesContainer.length <=1) && (pagger <= pagesContainer.length-6)">
          ..
          <button class="btn  {{pagesContainer.length == pagger ? 'active' : 'no'}}" (click)="getSearchPage(pagesContainer.length-1)">{{pagesContainer.length}}</button>
          <button class="btn " (click)="nextPage()"><a><span class="armx-icon armx-right-dir"></span></a></button>
        </li>
      </ul>
    </nav>
  </div>
</div>
